import { t } from '@lingui/core/macro';
import { ActivityDTO, ExpenseDTO } from '@luminovo/api-contracts';
import { Chip, Flexbox, IconElement, Text, Tooltip } from '@luminovo/design-system';
import { ClockIcon, DollarSignIcon } from 'lucide-react';
import type { JSX } from 'react';

export const ExpenseCountChip = ({ expenses }: { expenses: ExpenseDTO[] }): JSX.Element => {
    return <EntityCountChip heading={t`Expenses`} entities={expenses} icon={<DollarSignIcon />} />;
};

export const ActivityCountChip = ({ activities }: { activities: ActivityDTO[] }): JSX.Element => {
    return <EntityCountChip heading={t`Activities`} entities={activities} icon={<ClockIcon />} />;
};

const EntityCountChip = ({
    entities,
    heading,
    icon,
}: {
    heading: string;
    icon: IconElement;
    entities: ExpenseDTO[] | ActivityDTO[];
}): JSX.Element => {
    return (
        <Tooltip
            variant={'white'}
            title={
                <Flexbox
                    gap={'4px'}
                    sx={{
                        flexDirection: 'column',
                    }}
                >
                    <Text variant="h4">{heading}</Text>
                    {entities.map((entity) => (
                        <Text key={entity.id} variant="body">
                            {entity.name}
                        </Text>
                    ))}
                </Flexbox>
            }
        >
            <span>
                <Chip color={'neutral'} label={entities.length.toString()} startIcon={icon} />
            </span>
        </Tooltip>
    );
};
